<template>
  <div><h1>Favorite Lists</h1></div>
</template>

<script>
export default {
  name: 'FavoritesList'
};
</script>
